import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');

// 留学院校
const studyAbroad = r => require.ensure([], () => r(require('@/page/study-abroad/index')), 'studyAbroad');  //留学院校
const addOrEditStudyAbroad = r => require.ensure([], () => r(require('@/page/study-abroad/addOrEdit')), 'addOrEditStudyAbroad');  //新增院校

// 留学专业
const studyMajor = r => require.ensure([], () => r(require('@/page/study-major/index')), 'studyMajor');  //留学专业
const addOrEditStudyMajor = r => require.ensure([], () => r(require('@/page/study-major/addOrEdit')), 'addOrEditStudyMajor');  //新增留学专业

// 发布文章
const publishArticles = r => require.ensure([], () => r(require('@/page/publishArticles')), 'publishArticles');

// 案例分享
const caseSharing = r => require.ensure([], () => r(require('@/page/caseSharing')), 'caseSharing');
const categoryManage = r => require.ensure([], () => r(require('@/page/category-manage/index')), 'category-manage');

// 留学条件
const studyCondition = r => require.ensure([], () => r(require('@/page/studyCondition')), 'studyCondition');

//留学信息
const studyAbroadInfo = r => require.ensure([], () => r(require('@/page/studyAbroadInfo')), 'studyAbroadInfo');

const editArtical = r => require.ensure([], () => r(require('@/page/editArtical')), 'editArtical'); //编辑资讯
const friendLink = r => require.ensure([], () => r(require('@/page/friendLink')), 'friendLink'); //友情链接
const routes = [{
  path: '/',
  component: login,
},
  {
    path: '/login',
    component: login,
  },
  {
    path: '/manage',
    component: manage,
    name: '',
    children: [
      {
        path: '/studyAbroad',
        component: studyAbroad,
        meta: ['留学院校'],
      },
      {
        path: '/studyAbroad/addOrEditStudyAbroad',
        component: addOrEditStudyAbroad,
        meta: ['留学院校/新增院校'],
      },
      {
        path: '/studyAbroadInfo',
        component: studyAbroadInfo,
        meta: ['留学信息'],
      },
      {
        path: '/studyMajor',
        component: studyMajor,
        meta: ['留学专业'],
      },
      {
        path: '/studyMajor/addOrEditStudyMajor',
        component: addOrEditStudyMajor,
        meta: ['留学专业/新增专业'],
      },
      {
        path: '/category-manage',
        component: categoryManage,
        meta: ['分类管理'],
      },
      {
        path: '/caseSharing',
        component: caseSharing,
        meta: ['案例分享'],
      },
      {
        path: '/publishArticles',
        component: publishArticles,
        meta: ['发布文章'],
      },
      {
        path: '/studyCondition',
        component: studyCondition,
        meta: ['留学条件'],
      },
      // {
      //     path: '/friendLink',
      //     component: friendLink,
      //     meta: ['友情链接'],
      // },
      // {
      //     path: '/editArtical',
      //     component: editArtical,
      //     meta: ['编辑文章'],
      // },
    ],
  },

]

export default new Router({
  routes,
  // strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js